export default "__VITE_ASSET__0a0962e9__"